import { useEffect, useState, useRef } from 'react';
import RightArrowIcon from '../assets/icons/rightArrow';
import {
	BackImage1,
	heroImage,
	home_main_mobile,
	homemain,
} from '../assets/images';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import DashedBorder from '../assets/icons/border';
import countryCodes from '../Data/country-code.json';
import emailjs from 'emailjs-com';
import Downloadbroch from '../components/Downloadbroch';
import DownArrow from '../assets/icons/downArrowIcon';
import TickCircleIcon from '../assets/icons/tick-circle';
import TickMobileCircleIcon from '../assets/icons/tick-m';

const ContactUs = () => {
	const [isMdUp, setIsMdUp] = useState(window.innerWidth >= 768);
	const [errors, setErrors] = useState({});
	const [isSmallScreen, setIsSmallScreen] = useState(false);
	const [isSubmitClick, setIsSubmitClick] = useState(false);
	const iconSize = isSmallScreen ? 20 : 24;
	const [formData, setFormData] = useState({
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		message: '',
		dial_code: '+91',
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
		setErrors((prevErrors) => {
			const updatedErrors = { ...prevErrors };
			if (value.trim() !== '') {
				delete updatedErrors[name];
			}
			return updatedErrors;
		});
	};
	const handleSelectChange = (e) => {
		setFormData((prev) => ({ ...prev, dial_code: e.target.value }));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		const newErrors = {};
		if (!formData.firstName.trim())
			newErrors.firstName = 'First Name is required';
		if (!formData.email.trim()) newErrors.email = 'Email is required';
		else if (!/\S+@\S+\.\S+/.test(formData.email))
			newErrors.email = 'Enter a valid email address';
		if (!formData.phone.trim())
			newErrors.phone = 'Phone number is required';
		else if (!/^[0-9]{10}$/.test(formData.phone))
			newErrors.phone = 'Enter a valid 10-digit phone number';
		if (!formData.message.trim()) newErrors.message = 'Message is required';

		setErrors(newErrors);

		if (Object.keys(newErrors).length === 0) {
			setIsSubmitClick(true);
			emailjs
				.send(
					// 'service_znt5qwl',
					'service_czv2drh',
					// 'template_jgm4pkt',
					'template_p2p9o5h',
					{
						firstName: formData.firstName,
						lastName: formData.lastName,
						email: formData.email,
						dial_code: formData.dial_code,
						phone: formData.phone,
						message: formData.message,
					},
					'DeXco8uNnG82TFJ60',
				)
				.then(
					() => {
						console.log('Email sent successfully');
						setFormData({
							firstName: '',
							lastName: '',
							email: '',
							phone: '',
							message: '',
							dial_code: '+91',
						});
					},
					(error) => {
						console.error('Failed to send email:', error);
					},
				);
		}
	};

	useEffect(() => {
		const handleResize = () => setIsMdUp(window.innerWidth >= 768);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	useEffect(() => {
		const handleResize = () => {
			setIsSmallScreen(window.innerWidth < 640);
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);
	return (
		<div className="w-full">
			{/* <div className="relative overflow-hidden ">
				<div
					className="relative flex justify-center items-center h-[689px] xl:h-[566px] lg:h-[566px] md:h-[566px] sm:h-[689px] w-full"
					style={{
						backgroundImage: isSmallScreen
							? `
							linear-gradient(225.42deg, #000000 19.01%, rgba(0, 0, 0, 0) 28.12%, rgba(0, 0, 0, 0) 36.49%, rgba(0, 0, 0, 0.76) 47.51%, #000000 81.02%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%),
							url(${home_main_mobile})
							`
							: `
							linear-gradient(256.37deg, #000000 0%, rgba(0, 0, 0, 0) 14.68%, rgba(0, 0, 0, 0) 28.19%, rgba(0, 0, 0, 0.76) 66.31%, #000000 100%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%),
							url(${homemain})
							`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						backgroundSize: 'cover',
					}}
				>
					<Navbar />
					<span className="absolute max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full xl:pl-[100px] lg:pl-0 md:pl-0 sm:pl-0 ms:px-[20px] xs:px-[20px] flex flex-col justify-center">
						<h1 className="text-white xl:font-medium lg:font-medium md:font-medium sm:font-bold ms:font-bold xs:font-bold xl:text-[60px] lg:text-[60px] md:text-[32px] sm:text-[32px] text-[32px] leading-[140%] shadow-[0_4px_20px_0_#0000001F] flex items-center justify-start text-left text-goudy pt-[100px] sm:pt-[100px] md:pt-0 lg:pt-0 xl:pt-0">
							Contact Us
						</h1>
						<p className="w-[300px] sm:w-[256px] md:w-[410px] h-[64px] opacity-100 text-white font-normal text-[14px] sm:text-[14px] md:text-[14px] lg:text-[18px] xl:text-[18px] leading-[180%] shadow-[0_4px_20px_0_#0000001F] flex items-start justify-start text-left xl:mt-4 lg:mt-4 md:mt-4 sm:mt-[12px] mt-[12px] font-google">
							For any queries, questions, or to know more about
							our product range, feel free to reach out to us!
						</p>
					</span>
				</div>
			</div> */}
			<div className="relative overflow-hidden">
				<div
					className="relative flex justify-center items-center h-[689px] xl:h-[566px] lg:h-[566px] md:h-[566px] sm:h-[689px] w-full"
					style={{
						backgroundImage: isSmallScreen
							? `url(${home_main_mobile})`
							: `url(${homemain})`,
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center',
						backgroundSize: 'cover',
					}}
				>
					<div
						className="absolute inset-0 pointer-events-none "
						style={{
							 opacity: isSmallScreen ? "0.8" : "1",
							background: isSmallScreen
								? `
							linear-gradient(225.42deg, rgb(0, 0, 0) 1.01%, rgba(0, 0, 0, 0) 5.12%, rgba(0, 0, 0, 0) 21.49%, rgba(0, 0, 0, 0.76) 51.51%, rgb(0, 0, 0) 76.02%), linear-gradient(rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 19.91%, rgba(0, 0, 0, 0) 100%)
							`
				
													: `
							linear-gradient(256.37deg, #000000 0%, rgba(0, 0, 0, 0) 14.68%, rgba(0, 0, 0, 0) 28.19%, rgba(0, 0, 0, 0.76) 66.31%, #000000 100%),
							linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 14.91%, rgba(0, 0, 0, 0) 100%)
							`
						}}
					></div>

					<Navbar />

					<span className="absolute max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[393px] ms:w-full xs:w-full xl:pl-[100px] ms:px-[20px] xs:px-[20px] flex flex-col justify-center">
						<h1 className="text-white xl:font-medium lg:font-medium md:font-medium sm:font-bold ms:font-bold xs:font-bold xl:text-[60px] lg:text-[60px] md:text-[32px] sm:text-[32px] text-[32px] leading-[140%] shadow-[0_4px_20px_0_#0000001F] flex items-center justify-start text-left text-goudy pt-[100px] sm:pt-[100px] md:pt-0 lg:pt-0 xl:pt-0">
							Contact Us
						</h1>
						<p className="w-[300px] sm:w-[256px] md:w-[410px] h-[64px] opacity-100 text-white font-normal text-[14px] sm:text-[14px] md:text-[14px] lg:text-[18px] xl:text-[18px] leading-[180%] shadow-[0_4px_20px_0_#0000001F] flex items-start justify-start text-left xl:mt-4 lg:mt-4 md:mt-4 sm:mt-[12px] mt-[12px] font-google">
							For any queries, questions, or to know more about
							our product range, feel free to reach out to us!
						</p>
					</span>
				</div>
			</div>

			<div
				className={`relative flex flex-col  items-center xl:h-[990px] lg:h-[900px] md:h-[790px] sm:h-[787px] h-fit w-full ${
					isMdUp ? 'bg-contain' : 'bg-white'
				}`}
				style={{
					backgroundImage: isMdUp ? `url(${BackImage1})` : 'none',
					backgroundRepeat: isMdUp ? 'no-repeat' : 'none',
					backgroundSize: isMdUp ? 'auto' : 'none',
					backgroundPosition: isMdUp ? 'center bottom' : 'none',
				}}
			>
				<h2 className="xl:text-[52px] lg:text-[52px] md:text-[40px] sm:text-[28px] text-[28px] xl:font-normal lg:font-normal md:font-normal sm:font-bold font-bold text-black text-center leading-[100%] xl:pt-[140px] xl:pb-[50px] lg:py-10 md:pt-16 md:pb-6 pt-16 pb-5 text-goudy">
					Get In Touch
				</h2>
				<div
					className={`flex flex-col xl:w-[748px] lg:w-[748px] md:w-[700px] sm:w-full w-full bg-white rounded-[16px] md:rounded-[24px] md:shadow-[0_4px_20px_0_#0000000F] opacity-100 relative 
						${
							Object.keys(errors).length > 0
								? 'xl:h-[620px] lg:h-[620px] md:h-[560px] sm:h-fit h-fit'
								: 'xl:h-[582px] lg:h-[582px] md:h-[510px] sm:h-[670px] h-fit'
						}
					`}
				>
					{!isSmallScreen && (
						<DashedBorder
							radiusDesktop={24}
							radiusMobile={24}
						/>
					)}
					{isSubmitClick ? (
						<div className="w-full h-full flex flex-col justify-center items-center sm:mt-[100px] ms:mt-[100px] xs:mt-[100px] md:mt-0">
							{isSmallScreen ? (
								<TickMobileCircleIcon />
							) : (
								<TickCircleIcon />
							)}
							<h2 className="xl:text-[36px] lg:text-[36px] md:text-[36px] sm:text-[24px] text-[24px] text-center font-[400] pt-[32px] text-goudy">
								Message Submitted!
							</h2>
							<p className="xl:w-[469px] lg:w-[469px] md:w-[469px] sm:w-[353px] w-full px-2 pt-[16px] text-center xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[14px] font-[400] font-google text-[#1D1D1D] xl:leading-[150%] lg:leading-[150%] md:leading-[150%] sm:leading-[180%] leading-[180%] tracking-[0]">
								Thank you for reaching out! Your message has
								been received, and our team will get back to you
								as soon as possible.
								<br />
								<br />
								If your request is urgent, please contact us
								directly at
								<br />
								<a
									href="mailto:contact@zecca.in"
									className="underline decoration-solid underline-offset-[4px]"
								>
									contact@zecca.in
								</a>{' '}
								or{' '}
								<a
									href="tel:+919909009023"
									className="underline decoration-solid underline-offset-[4px]"
								>
									+91 99090 09023
								</a>
								.
							</p>
						</div>
					) : (
						<>
							<div className="flex flex-col md:flex-row gap-[16px] md:gap-[28px] md:px-[44px] px-4 w-full pt-[24px] md:pt-[40px]">
								<div className="flex flex-col md:w-[316px] w-full">
									<label className="text-[14px] font-semibold text-black pb-[4px] md:pb-[8px] font-plusJakarta">
										First Name
										<span className="text-red-500">*</span>
									</label>
									<input
										type="text"
										name="firstName"
										placeholder="Enter First Name"
										className="border border-[#C4BAA3] rounded-[16px] md:rounded-[18px] pt-[10px] pr-[24px] pb-[14px] pl-[20px] outline-none focus:ring-1 focus:ring-[#C4BAA3] text-black placeholder:text-black/60 placeholder:font-plusJakarta placeholder:font-normal placeholder:text-[14px] md:placeholder:text-[16px] placeholder:leading-[100%] h-[52px] md:h-auto"
										value={formData.firstName}
										onChange={handleChange}
										style={{
											WebkitBoxShadow:
												'0 0 0px 1000px #fff inset',
											backgroundColor: 'transparent',
											WebkitTextFillColor: '#000',
										}}
									/>
									{errors.firstName && (
										<p className="text-red-500 text-[12px] font-plusJakarta font-semibold pl-2">
											{errors.firstName}
										</p>
									)}
								</div>
								<div className="flex flex-col md:w-[316px] w-full">
									<label className="text-[14px] font-semibold text-black pb-[4px] md:pb-[8px] font-plusJakarta">
										Last Name
									</label>
									<input
										type="text"
										name="lastName"
										placeholder="Enter Last Name (optional)"
										className="border border-[#C4BAA3] rounded-[16px] md:rounded-[18px] pt-[10px] pr-[24px] pb-[14px] pl-[20px] outline-none focus:ring-1 focus:ring-[#C4BAA3] text-black placeholder:text-black/60 placeholder:font-plusJakarta placeholder:font-normal placeholder:text-[14px] md:placeholder:text-[16px] placeholder:leading-[100%] h-[52px] md:h-auto"
										value={formData.lastName}
										onChange={handleChange}
										style={{
											WebkitBoxShadow:
												'0 0 0px 1000px #fff inset',
											backgroundColor: 'transparent',
											WebkitTextFillColor: '#000',
										}}
									/>
								</div>
							</div>
							<div className="flex flex-col md:flex-row gap-[16px] md:gap-[28px] md:px-[44px] px-4 w-full pt-[20px] md:pt-[28px]">
								<div className="flex flex-col md:w-[316px] w-full">
									<label className="text-[14px] font-semibold text-black pb-[4px] md:pb-[8px] font-plusJakarta">
										Email
										<span className="text-red-500">*</span>
									</label>
									<input
										type="email"
										placeholder="Enter Email"
										className="border border-[#C4BAA3] rounded-[16px] md:rounded-[18px] pt-[10px] pr-[24px] pb-[14px] pl-[20px] outline-none focus:ring-1 focus:ring-[#C4BAA3] text-black placeholder:text-black/60 placeholder:font-plusJakarta placeholder:font-normal placeholder:text-[14px] md:placeholder:text-[16px] placeholder:leading-[100%] h-[54px] md:h-auto"
										value={formData.email}
										onChange={handleChange}
										name="email"
										style={{
											WebkitBoxShadow:
												'0 0 0px 1000px #fff inset',
											backgroundColor: 'transparent',
											WebkitTextFillColor: '#000',
										}}
									/>
									{errors.email && (
										<p className="text-red-500 text-[12px] font-plusJakarta font-semibold pl-2">
											{errors.email}
										</p>
									)}
								</div>
								<PhoneInputWithCountryCode
									countryCodes={countryCodes}
									formData={formData}
									setFormData={setFormData}
									errors={errors}
									handleChange={handleChange}
								/>
							</div>
							<div className="flex flex-col md:px-[44px] px-4 w-full pt-[20px] md:pt-[28px]">
								<label className="text-[14px] font-semibold text-black pb-[4px] md:pb-[8px] font-plusJakarta">
									Message
									<span className="text-red-500">*</span>
								</label>
								<textarea
									rows="4"
									placeholder="Enter Message"
									className="border border-[#C4BAA3] rounded-[16px] md:rounded-[18px] pt-[10px] pr-[24px] pb-[14px] pl-[20px] outline-none focus:ring-1 focus:ring-[#C4BAA3] resize-none text-black placeholder:text-black/60 placeholder:font-plusJakarta placeholder:font-normal placeholder:text-[14px] md:placeholder:text-[16px] placeholder:leading-[100%] h-[133px] md:h-auto"
									name="message"
									value={formData.message}
									onChange={handleChange}
									style={{
										WebkitBoxShadow:
											'0 0 0px 1000px #fff inset',
										backgroundColor: 'transparent',
										WebkitTextFillColor: '#000',
									}}
								></textarea>
								{errors.message && (
									<p className="text-red-500 text-[12px] font-plusJakarta font-semibold pl-2">
										{errors.message}
									</p>
								)}
							</div>
						</>
					)}
					{!isSmallScreen && (
						<div
							className="relative h-0 opacity-100 xl:mt-[44px] xl:mb-[40px] lg:mt-[44px] lg:mb-[40px] md:mt-[20px] md:mb-[20px] sm:mt-[20px] sm:mb-0"
							style={{
								boxShadow: '0px 4px 20px 0px #00000014',
							}}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="100%"
								height="1"
								className="absolute top-0 left-0"
							>
								<line
									x1="0"
									y1="0"
									x2="100%"
									y2="0"
									stroke="#C4BAA3"
									strokeWidth="2"
									strokeDasharray="5,5"
								/>
							</svg>
						</div>
					)}
					{isSubmitClick ? (
						<button
							className="bg-black mx-auto xl:mt-0 lg:mt-0 md:mt-0 sm:mt-[100px] ms:mt-[100px] xs:mt-[100px] justify-center mb-[40px] text-white w-[279px] rounded-[30px] py-[10px] px-[24px] flex items-center gap-[10px] font-google font-[500] xl:text-[16px] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[14px]"
							onClick={() => {
								setIsSubmitClick(false);
							}}
						>
							Submit another Message
							<RightArrowIcon
								width={iconSize}
								height={iconSize}
							/>
						</button>
					) : (
						<span className="flex md:justify-end justify-center md:pr-[44px] pr-0 md:my-0 my-[22px] mx-4 md:mx-0">
							<button
								className="bg-black text-white rounded-full md:px-[24px] px-8 md:py-[10px] py-3 flex items-center justify-center gap-2 cursor-pointer md:w-auto w-full text-white md:text-[16px] text-[14px] font-google font-medium leading-[100%] tracking-[0%]"
								onClick={(e) => {
									handleSubmit(e);
								}}
							>
								Submit
								<RightArrowIcon
									width={iconSize}
									height={iconSize}
								/>
							</button>
						</span>
					)}
				</div>
			</div>
			<Downloadbroch />
			<Footer />
		</div>
	);
};
export default ContactUs;
const PhoneInputWithCountryCode = ({
	countryCodes,
	formData,
	setFormData,
	errors,
	handleChange,
}) => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const ref = useRef();
	const searchTimeout = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (ref.current && !ref.current.contains(event.target)) {
				setIsDropdownOpen(false);
				setSearchTerm('');
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const handleSelectChange = (dial_code) => {
		setFormData((prev) => ({ ...prev, dial_code }));
		setIsDropdownOpen(false);
		setSearchTerm('');
	};

	const filteredCountries = searchTerm
		? countryCodes.filter((country) =>
				country.name.toLowerCase().startsWith(searchTerm),
		  )
		: countryCodes;

	return (
		<div
			className="flex flex-col"
			ref={ref}
		>
			<label className="text-[14px] font-semibold text-black pb-[8px] font-plusJakarta">
				Phone/Contact Number
				<span className="text-red-500">*</span>
			</label>

			<div className="flex border border-[#C4BAA3] rounded-[18px] pl-5 pr-6 pb-4 pt-3 relative w-full md:w-[316px]">
				<div
					className="cursor-pointer text-black bg-white rounded-l-[18px] select-none flex items-center gap-2"
					onClick={() => setIsDropdownOpen((open) => !open)}
				>
					{formData.dial_code}
					<DownArrow />
				</div>

				{isDropdownOpen && (
					// <ul className="absolute top-full left-0 mt-1 max-h-48 overflow-auto rounded-md bg-white border border-[#C4BAA3] shadow-lg z-50">
					<ul className="absolute top-full left-0 mt-1 max-h-48 w-full overflow-auto rounded-md bg-white border border-[#C4BAA3] shadow-lg z-50">
						<li className="sticky top-0 bg-white px-3 py-2 border-b border-gray-200">
							<input
								type="text"
								autoFocus
								placeholder="Search country..."
								value={searchTerm}
								onChange={(e) =>
									setSearchTerm(e.target.value.toLowerCase())
								}
								className="w-full px-2 py-1 border border-gray-300 rounded-md outline-none text-black"
							/>
						</li>
						{filteredCountries.length > 0 ? (
							filteredCountries.map((country, index) => (
								<li
									key={index}
									className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-black"
									onClick={() =>
										handleSelectChange(country.dial_code)
									}
								>
									{country.name} ({country.dial_code})
								</li>
							))
						) : (
							<li className="px-3 py-2 text-gray-500 cursor-default">
								No match
							</li>
						)}
					</ul>
				)}
				<div className="w-[1px] h-[24px] bg-[#DEDEDE] self-center xl:mx-3 lg:mx-3 md:mx-3 sm:mx-3 ms:mx-3 xs:mx-2 shrink-0"></div>
				<input
					type="tel"
					className="flex-1 outline-none border-none font-plusJakarta"
					name="phone"
					value={formData.phone}
					onChange={handleChange}
					required
					style={{
						WebkitBoxShadow: '0 0 0px 1000px #fff inset',
						backgroundColor: 'transparent',
						WebkitTextFillColor: '#000',
					}}
				/>
			</div>

			{errors.phone && (
				<p className="text-red-500 text-[12px] font-plusJakarta font-semibold pl-2">
					{errors.phone}
				</p>
			)}
		</div>
	);
};
